import { shouldOfferGuidedTour } from '~/lib/workspaceTour';

export function useFeatureGuideProgress(guideId: string, version = 1) {
  const userStore = useUserStore();
  const tenantStore = useTenantStore();
  const open = ref(false);

  function offerIfEligible(eligible = true) {
    if (
      eligible
      && shouldOfferGuidedTour(
        userStore.user?.preferences,
        tenantStore.currentTenantId,
        guideId,
        version,
      )
    ) {
      open.value = true;
      return true;
    }
    return false;
  }

  function show() {
    open.value = true;
  }

  async function saveOutcome(status: 'completed' | 'dismissed') {
    try {
      await userStore.updateGuidedTourProgress(tenantStore.currentTenantId, guideId, {
        status,
        version,
      });
    } catch (error) {
      console.warn(`Feature guide progress could not be saved for ${guideId}:`, error);
    }
  }

  function dismiss() {
    void saveOutcome('dismissed');
  }

  function complete(action?: () => void | Promise<void>) {
    void saveOutcome('completed');
    if (action) void action();
  }

  return {
    open,
    offerIfEligible,
    show,
    dismiss,
    complete,
  };
}
